export class Resource {
    public static BASE: string = "wp-content/themes/eventfive.awi.video-stories/";
    public static DATA: string = "wp-json/data-api/v1/data?nonce=19840730";
    public static SITE: string = "./";
    public static ASSETS: string = "/";

    public static init(element: HTMLElement): void {
        this.DATA = element.getAttribute("data-data");
        this.BASE = element.getAttribute("data-base");
        this.SITE = element.getAttribute("data-site");
        this.ASSETS = this.BASE + "assets";
    }

    public static resolve(path: string): string {
        return this.join(this.BASE, path);
    }

    public static asset(path: string): string {
        return this.join(this.ASSETS, path);
    }

    private static join(pathA: string, pathB: string): string {
        if (pathA[pathA.length - 1] === "/")
            pathA = pathA.substr(0, pathA.length - 1);
        if (!pathB) {
            return pathA;
        }
        if (pathB[0] === "/")
            pathB = pathB.substr(1);
        return pathA + "/" + pathB;
    }
}